import { MessageBox } from "element-ui"
import store from "@/store"
import { Base64 } from 'js-base64';
function checkLoginStatus() {
    if (!store.getters.token && !store.getters.confirmStatus) {
        store.commit('CONFIRM_TRUE')
        MessageBox.confirm(
            "请先登录",
            "系统提示", {
            confirmButtonText: "重新登录",
            type: "warning",
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
        }
        ).then(() => {
            store.dispatch("deleteCommonDataAction").then(() => {
                window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
            })
            store.commit('CONFIRM_FALSE')
        })
    }
}
//小数点处理
function keepDecimal(val, index) {
    return (val || val === 0) ? val.toFixed(index) : ''
}
//脱敏 
function desensitization(old) {
    if (!old) {
        return "";
    }
    let str = old.substr(0, 1);
    for (let i = 1; i < old.length - 1; i++) {
        str += '*';
    }
    str += old.substr(old.length - 1, old.length)
    return str;
}
//文字转义 1是0否
function isTransfer(str) {
    if (str == 1 || str == '1') {
        return "是"
    } else if (str == 0 || str == '0') {
        return "否"
    } else {
        return ''
    }
}
function yearSplit(str) {
    return str ? str.slice(0, 4) : ''
}

function arrtostr(arr) {
    return arr?.join(';') || null
}
function strtoarr(str) {
    return str?.split(';') || []
}
function arrtostr2(arr) {
    return arr?.join(',') || null
}
function strtoarr2(str) {
    return str?.split(',') || []
}


function plusXing(str, frontLen, endLen, content) { //frontLen *前面的长度  endLen*后面的长度
    let len = str.length - frontLen - endLen;
    let xing = "";
    for (let i = 0; i < len; i++) {
        xing += content;
    }
    return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    );
}
function download(res, text = '模板下载') {
    const elink = document.createElement('a');
    elink.download = text;  //定义表格名称，后缀是文件格式
    elink.style.display = 'none';
    const blob = new Blob([res.data], { type: 'text/csv,charset=UTF-8' });
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    document.body.removeChild(elink);
}
function downloadFile(res, text = '附件下载') {
    const a = document.createElement("a"); //创建一个标签
  // 增加type 配置，设置下载资源的类型
  a.href = window.URL.createObjectURL(res);

  let pattern = new RegExp("filename=([^;]+\\.[^.;]+);*");
  let contentDisposition = decodeURI(res["content-disposition"]);
  let result = pattern.exec(contentDisposition);

  a.download = "导出.xlsx"; //文件名称
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
function getTypeText(type){
   return {
     1:'孵化级',
     2:'成长级',
     3:'样板级',
   }[type] || type
}
function jzzlogin(){
    store.dispatch("deleteCommonDataAction").then(() => {
        window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
    })
}
// el-form表单验证失败，滚动定位到第一个元素
function scrollIntoView(className = 'is-error', block = 'center') {
    Promise.resolve().then(() => {
      const target = document.getElementsByClassName(className)
      if (target.length) {
        target[0].scrollIntoView({
          behavior: 'smooth', // 平滑过渡 值有auto、instant,smooth，缓动动画（当前是慢速的）
          block: block // 上边框与视窗顶部平齐。默认值 值有start,center,end，nearest，当前显示在视图区域中间
        })
      }
    })
  }
  //清除级联children=[]的节点
function clearEmptyChildren(list) {
    list.forEach(e=>{
        if(Array.isArray(e.children) && e.children.length){
          this.clearEmptyChildren(e.children)
        }else {
          e.children = null
        }
    })
  }
export default {
    keepDecimal, desensitization, isTransfer, yearSplit,  arrtostr, strtoarr,arrtostr2, strtoarr2,  plusXing, checkLoginStatus, download,
    downloadFile,getTypeText,jzzlogin,scrollIntoView,clearEmptyChildren
}